module.exports = __webpack_public_path__ + "img/house-live.118d4718.png";